var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4788 14.3963L26.8538 4.77125C26.6605 4.5778 26.3984 4.46899 26.125 4.46875H9.625C8.98682 4.46875 8.37478 4.72227 7.92352 5.17352C7.47227 5.62478 7.21875 6.23682 7.21875 6.875V37.125C7.21875 37.7632 7.47227 38.3752 7.92352 38.8265C8.37478 39.2777 8.98682 39.5312 9.625 39.5312H34.375C35.0132 39.5312 35.6252 39.2777 36.0765 38.8265C36.5277 38.3752 36.7812 37.7632 36.7812 37.125V15.125C36.781 14.8516 36.6722 14.5895 36.4788 14.3963ZM27.1562 7.98875L33.2613 14.0938H27.1562V7.98875ZM34.375 37.4688H9.625C9.53383 37.4688 9.4464 37.4325 9.38193 37.3681C9.31747 37.3036 9.28125 37.2162 9.28125 37.125V6.875C9.28125 6.78383 9.31747 6.6964 9.38193 6.63193C9.4464 6.56747 9.53383 6.53125 9.625 6.53125H25.0938V15.125C25.0938 15.3985 25.2024 15.6608 25.3958 15.8542C25.5892 16.0476 25.8515 16.1562 26.125 16.1562H34.7188V37.125C34.7188 37.2162 34.6825 37.3036 34.6181 37.3681C34.5536 37.4325 34.4662 37.4688 34.375 37.4688Z",
    fill: "#586066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9f014be8cdfe2318356d72049443f9d6.svg";
export { ForwardRef as ReactComponent };